import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import ProfileInfo from './ProfileInfo';
import ReferralRewardHistory from "./ReferralRewardHistory";
import SingleDepositHistory from "./SingleDepositHistory";

import { useLocation, useParams } from 'react-router-dom';
import { useSingleUserHistory } from './UserDetailapi';

import { PageLoader } from '../../lib/loader';
import ReferralManagement from './ReferralManagement';
import { useModalContext } from '../../contexts/ModalContext';
import TransactionHistory from './TransactionHistory';

const UserHistory = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('profile');
    const { id } = useParams();
    const { theme } = useModalContext();
    const { data: getOneUser, isLoading, error } = useSingleUserHistory({ id });

    useEffect(() => {
        if (location.state?.lastActiveTab) {
            setActiveTab(location.state.lastActiveTab);
        }
    }, [location.state]);





    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    if (isLoading) {
        return <PageLoader />;
    }

    if (error || !getOneUser) {
        return <div><PageLoader /></div>;
    }


    return (
        <div className='SettingsPageMain '>
            <div className="ad_pg_bx p-2" style={{ minHeight: "70vh" }}>
                <Nav tabs className='mb-4' style={{ background: theme ? '#000' : '#ffff' }}>
                    <NavItem className='flex-fill'>
                        <NavLink className={classnames({ active: activeTab === 'profile' })} onClick={() => { toggle('profile'); }}>Profile Info</NavLink>
                    </NavItem>

                    <NavItem className='flex-fill'>
                        <NavLink className={classnames({ active: activeTab === 'Referral' })} onClick={() => { toggle('Referral'); }}>Referral </NavLink>
                    </NavItem>
                    {/* <NavItem className='flex-fill'>
                        <NavLink className={classnames({ active: activeTab === 'Referral Reward' })} onClick={() => { toggle('Referral Reward'); }}>Referral Reward</NavLink>
                    </NavItem> */}
                    <NavItem className='flex-fill'>
                        <NavLink className={classnames({ active: activeTab === 'Transaction History' })} onClick={() => { toggle('Transaction History'); }}>Transaction History </NavLink>
                    </NavItem>



                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="profile">
                        {activeTab === "profile" && <ProfileInfo userDetail={getOneUser?.data} />}
                    </TabPane>
                    <TabPane tabId="Referral">
                        {activeTab === "Referral" && <ReferralManagement activeTab="Referral" />}
                    </TabPane>
                    {/* <TabPane tabId="Referral Reward">
                        {activeTab === "Referral Reward" && <ReferralRewardHistory activeTab="Referral Reward" userDetail={getOneUser?.data} />}
                    </TabPane> */}
                    <TabPane tabId="Transaction History">
                        {activeTab === "Transaction History" && <TransactionHistory activeTab="Transaction History" />}
                    </TabPane>

                </TabContent>
            </div>
        </div>
    );
};

export default UserHistory;
